import { render, staticRenderFns } from "./QQQuestionarioRCSanitario.vue?vue&type=template&id=e3300aa2&"
import script from "./QQQuestionarioRCSanitario.vue?vue&type=script&lang=js&"
export * from "./QQQuestionarioRCSanitario.vue?vue&type=script&lang=js&"
import style0 from "./QQQuestionarioRCSanitario.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QList,QItem,QItemSection,QItemLabel,QCheckbox});
